import React from "react";
import { Link } from "react-router-dom";
import bannerImg from "../../images/main-banner.png";
import titalEvents from "../../images/baseball3.jpg";
import hockey from "../../images/hockey.jpg";
import infoBg from "../../images/Football2.jpg";
import Header from "../../components/user/Header";
import Footer from "../../components/user/Footer";

export default function TitanLanding() {
  return (
    <div className="bg-white">
      <Header />

      {/* Hero Section */}
      <section
        className="position-relative text-white d-flex align-items-center"
        style={{
          backgroundImage: `url(${bannerImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "85vh",
        }}
      >
        <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-75"></div>

        <div className="container position-relative py-5">
          <div className="row justify-content-center text-center">
            <div className="col-12 col-lg-10 col-xl-8">
              <span className="badge rounded-pill text-bg-light text-dark px-3 py-2 mb-3">
                Official NLSA USA Performance Platform
              </span>

              <h1 className="display-4 fw-bold mb-3">The NLSA CHALLENGE</h1>

              <p className="lead mb-4">
                Athlete Performance Testing & Certification Platform
              </p>

              <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
                <Link to="/start" className="btn btn-primary btn-lg px-4">
                  Start Your NLSA CHALLENGE
                </Link>

                <Link to="/dashboard" className="btn btn-outline-light btn-lg px-4">
                  View Athlete Dashboard
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Intro Cards */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row g-4 text-center">
            <div className="col-12 col-md-4">
              <div className="card h-100 border-0 shadow-sm rounded-4">
                <div className="card-body p-4">
                  <h5 className="fw-bold mb-2">Official Testing</h5>
                  <p className="text-muted mb-0">
                    Participate in structured athlete testing designed to measure real
                    performance with consistency and credibility.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="card h-100 border-0 shadow-sm rounded-4">
                <div className="card-body p-4">
                  <h5 className="fw-bold mb-2">Verified Athlete Stats</h5>
                  <p className="text-muted mb-0">
                    Build an athlete profile with measurable results across speed,
                    strength, endurance, and sport-specific performance.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="card h-100 border-0 shadow-sm rounded-4">
                <div className="card-body p-4">
                  <h5 className="fw-bold mb-2">Nationwide Recognition</h5>
                  <p className="text-muted mb-0">
                    Earn official certifications and compare yourself against athletes
                    across the country through the NLSA CHALLENGE system.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Content Blocks */}
      <section className="py-5">
        <div className="container">
          <div className="row g-4 align-items-center mb-5">
            <div className="col-12 col-lg-5">
              <img
                src={titalEvents}
                alt="Titan Events"
                className="img-fluid rounded-4 shadow w-100"
              />
            </div>

            <div className="col-12 col-lg-7">
              <span className="badge text-bg-primary rounded-pill px-3 py-2 mb-3">
                Upcoming Events
              </span>
              <h2 className="fw-bold mb-3">Upcoming NLSA CHALLENGE Events</h2>
              <p className="text-secondary mb-4">
                Find out where the next NLSA CHALLENGE events are happening. Our
                nationwide events give athletes the chance to complete official tests,
                record certified scores, and compete in real environments. Each event
                is professionally organized, staffed by NLSA officials, and designed
                to deliver an authentic competitive experience.
              </p>
              <a
                href="https://nlsausa.com/events"
                rel="noreferrer"
                className="btn btn-primary btn-lg"
              >
                See Events
              </a>
            </div>
          </div>

          <div className="row g-4 align-items-center">
            <div className="col-12 col-lg-7 order-2 order-lg-1">
              <span className="badge text-bg-dark rounded-pill px-3 py-2 mb-3">
                NLSA CHALLENGE System
              </span>
              <h2 className="fw-bold mb-3">How The NLSA CHALLENGE System Works</h2>
              <p className="text-secondary mb-4">
                Learn how scoring, stats, tiers, and certifications work together.
                The NLSA CHALLENGE System breaks performance into verified, measurable categories
                across strength, speed, endurance, and sport-specific testing. Every
                test contributes to your official NLSA athlete profile, helping you
                progress through tier levels and earn recognized certifications that
                prove your athletic level with real data.
              </p>
              <a
                href="https://nlsausa.com/titan-info"
                rel="noreferrer"
                className="btn btn-outline-primary btn-lg"
              >
                Learn More
              </a>
            </div>

            <div className="col-12 col-lg-5 order-1 order-lg-2">
              <img
                src={hockey}
                alt="How NLSA CHALLENGE Works"
                className="img-fluid rounded-4 shadow w-100"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Highlight CTA */}
      <section
        className="position-relative text-white py-5"
        style={{
          backgroundImage: `url(${infoBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-75"></div>

        <div className="container position-relative py-4">
          <div className="row justify-content-center text-center">
            <div className="col-12 col-lg-9">
              <span className="badge rounded-pill text-bg-light text-dark px-3 py-2 mb-3">
                Athlete Certification System
              </span>

              <h2 className="fw-bold mb-3">What is the NLSA CHALLENGE?</h2>

              <p className="lead mb-3">
                The NLSA CHALLENGE is the official athlete performance certification
                system by NLSA USA.
              </p>

              <p className="mb-4">
                Measure your skills, earn certifications, and join a nationwide
                scoreboard of athletes participating in competitive testing. Whether
                you are aiming to compete professionally or simply want to train at a
                higher level, NLSA CHALLENGE gives you a verified path to prove your performance.
              </p>

              <Link to="/start" className="btn btn-light btn-lg px-4">
                Start Now
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Strip */}
      <section className="py-5 bg-light border-top">
        <div className="container">
          <div className="row align-items-center text-center text-lg-start">
            <div className="col-12 col-lg-8 mb-3 mb-lg-0">
              <h3 className="fw-bold mb-2">Ready to test, rank, and get certified?</h3>
              <p className="text-muted mb-0">
                Join the NLSA CHALLENGE and start building your official athlete profile.
              </p>
            </div>
            <div className="col-12 col-lg-4 text-lg-end">
              <Link to="/start" className="btn btn-primary btn-lg px-4">
                Begin Your Challenge
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}